export interface Chat {
    threadId: string;
    threadName: string;
    completeChat: ChatItem[];
}
export interface ChatItem {
    threadId: string;
    message: ChatItemMessage;
}

export interface ChatItemMessage {
    id: string;
    role: 'user' | 'assistant' | string;
    createdAt: string; // ISO date string
    contentItems: ChatItemContent[];
    attachments: Attachment[]; // refine if attachment structure is known
}

export class EphemeralChatItemMessage {
    id: string;
    role: 'user' | 'assistant' | string;
    createdAt: string;
    contentItems: ChatItemContent[];
    attachments: Attachment[];

    constructor(init: Partial<ChatItemMessage>) {
        this.id = init.id || '';
        this.role = init.role || 'user';
        this.createdAt = init.createdAt || new Date().toISOString();
        this.contentItems = init.contentItems || [];
        this.attachments = init.attachments || [];
    }
}

interface ChatItemContent {
    type: 'text' | 'image' | string;
    text: string;
}
export interface Attachment {
    name: string;
}

export class Prompt {
    userPrompt: string;
    threadId: string;
    userId: string;
    attachments?: Attachment[];

    constructor(
        userPrompt: string,
        threadId: string,
        userId: string,
        attachments?: Attachment[],
    ) {
        this.userPrompt = userPrompt;
        this.threadId = threadId;
        this.userId = userId;
        this.attachments = attachments;
    }
}

export interface WelcomeMessage {
    threadId: string | null;
}

export class Thread {
    threadId: string;
    userId: string;
    createDate: string;
    threadName?: string;

    constructor(init: Partial<Thread>) {
        this.threadId = init.threadId;
        this.userId = init.userId;
        this.createDate = init.createDate;
        this.threadName = init.threadName;
    }
}
